import {
  FETCH_STUDENT_REQUESTS_REQUEST,
  FETCH_STUDENT_REQUESTS_SUCCESS,
  FETCH_STUDENT_REQUESTS_FAILURE,
  CLEAR_STUDENT_REQUESTS,
} from "../Actions/studentCourseRequestAction";

const initialState = {};

export const studentCourseRequestReducer = (state = initialState, action) => {
  const { teacherCourseId } = action;

  switch (action.type) {
    case FETCH_STUDENT_REQUESTS_REQUEST:
      return {
        ...state,
        [teacherCourseId]: { loading: true, requests: [], error: null },
      };
    case FETCH_STUDENT_REQUESTS_SUCCESS:
      return {
        ...state,
        [teacherCourseId]: {
          loading: false,
          requests: action.payload,
          error: null,
        },
      };
    case FETCH_STUDENT_REQUESTS_FAILURE:
      return {
        ...state,
        [teacherCourseId]: {
          loading: false,
          requests: [],
          error: action.payload,
        },
      };
    case CLEAR_STUDENT_REQUESTS:
      return {}; // Completely resets the request state
    default:
      return state;
  }
};
